/* Vapour Central completion pass 2.0.10.32: content-page restraint and review mockups. */
(function(){
  'use strict';
  var SELECTOR_ROOT = '#MainContent';
  function norm(value){ return (value || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function closestSection(el){ return el && (el.closest('section, .shopify-section, [id^="shopify-section-"]') || el.parentElement); }
  function visible(el){ if(!el) return false; var s = getComputedStyle(el); return s.display !== 'none' && s.visibility !== 'hidden' && el.getClientRects().length > 0; }

  function removeRecentlyViewed(root){
    (root || document).querySelectorAll('[id*="recently-viewed" i],[class*="recently-viewed" i],[data-section-type*="recently-viewed" i],[data-section-id*="recently-viewed" i]').forEach(function(el){
      var section = el.closest('section,.shopify-section,[id^="shopify-section-"]') || el;
      if(section.matches('[data-vc-recently-viewed]') || section.querySelector('[data-vc-recently-viewed]')) return;
      section.setAttribute('hidden', 'hidden');
      section.setAttribute('aria-hidden', 'true');
    });
  }

  function fixDuplicateHeading(){
    if(!document.body.classList.contains('template-page')) return;
    var main = document.querySelector(SELECTOR_ROOT); if(!main) return;
    var headings = Array.prototype.slice.call(main.querySelectorAll('h1')).filter(visible);
    if(headings.length < 2) return;
    var first = headings[0], second = headings[1], a = norm(first.textContent), b = norm(second.textContent);
    var similar = a && b && (a === b || ((a.indexOf(b) > -1 || b.indexOf(a) > -1) && Math.abs(a.length - b.length) < 12));
    if(!similar || first.getBoundingClientRect().top >= 720) return;
    var wrap = first.closest('.page-header,.page-title,.page-heading,.breadcrumb-title,.title-wrapper,.main-page-title,.page-header-wrapper');
    if(wrap && !wrap.contains(second)) wrap.classList.add('vc-duplicate-heading-wrap');
    else first.classList.add('vc-duplicate-heading');
    document.body.classList.add('vc-double-heading-fixed');
  }

  function classifySections(root){
    (root || document).querySelectorAll('h1,h2,h3').forEach(function(heading){
      var text = norm(heading.textContent), section = closestSection(heading); if(!section) return;
      if(/nicotine alternative|nic alternatives|nootropic/.test(text)) section.classList.add('vc-nic-alternatives');
      if(/starter kit|getting started|new to vaping/.test(text)) section.classList.add('vc-starter-section');
    });
  }

  function enhanceDelivery(root){
    var selectors = ['[data-free-shipping]','[data-free-delivery]','.free-shipping-bar','.free-shipping-progress','.shipping-progress','.cart-free-shipping','[class*="free-delivery" i]'];
    (root || document).querySelectorAll(selectors.join(',')).forEach(function(el){
      if(el.closest('header') && !el.closest('.cart,.drawer,.mini-cart')) return;
      el.classList.add('vc-free-delivery--enhanced');
    });
  }

  function init(root){
    removeRecentlyViewed(root);
    classifySections(root);
    enhanceDelivery(root);
    window.requestAnimationFrame(fixDuplicateHeading);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
